import { PayloadAction } from "@reduxjs/toolkit";
import { put, takeLatest } from "redux-saga/effects";
import { ToastNotifyError } from "../../../components/ToastNotify";
import { ENDPOINTS } from "../../../config/endpoints";
import api from "../../../services/apiService";
import {
  callLaunchConfigApi,
  getUserAttribute,
  getUserAttributeFailed,
  getUserAttributeSucess,
  launchConfigApiFailed,
  launchConfigApiSucess,
  callConfigApi,
  callTransactionLimitConfigApi,
  transactionLimitConfigApiSucess,
  transactionLimitConfigApiFailed
} from "../../slices/configSlice";
import { AxiosResponse } from "axios";



function* fetchLaunchConfig(action: PayloadAction<any>): Generator {
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.CONFIG.launchConfig,
      hideLoader: action?.payload?.hideLoader
    });
    if (!!response?.data && response?.status === 200) {
      yield put(launchConfigApiSucess(response.data?.result));
      !!action?.payload?.callback && action.payload.callback(response.data?.result?.data?.[0]);
    } else {
      ToastNotifyError(response?.data?.message);
      yield put(launchConfigApiFailed(response));
    }
  }
  catch (error) {
    yield put(launchConfigApiFailed(error));
  }
}


function* fetchConfig(action: PayloadAction<any>): Generator {
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.CONFIG.fetchConfig(action.payload.configType),
      hideLoader: action?.payload?.hideLoader
    });
    if (!!response?.data && response?.status === 200) {
      action?.payload?.successCallback(response.data?.result?.data);
    } else {
      ToastNotifyError(response?.data?.message);
      action?.payload?.errorCallback();
    }
  }
  catch (error) {
    action?.payload?.errorCallback();
  }
}

function* fetchUserAttribute(action: PayloadAction<any>): Generator {
  let payload = action.payload;
  try {
    const response = (yield api.request({
      method: "POST",
      url: ENDPOINTS.userAttributes,
      data: payload.data,
      hideLoader: payload?.hideLoader,
    })) as AxiosResponse;

    if (response && response?.data?.statusCode === 200 && !!response?.data?.result?.msisdnCorrelationId) {
      yield put(getUserAttributeSucess(response.data.result.msisdnCorrelationId));
      !!action?.payload?.callback && action.payload.callback(response.data.result.msisdnCorrelationId);
    } else {
      yield put(getUserAttributeFailed(""));
    }
  } catch (error) {
    yield put(getUserAttributeFailed(error));
  }
}

function* fetchTransactionLimitConfig(action: PayloadAction<any>): Generator {
  try {
    const response: any = yield api.request({
      method: "GET",
      url: ENDPOINTS.CONFIG.limitConfig,
      hideLoader: action?.payload?.hideLoader
    });
    if (!!response?.data && response?.status === 200) {
      yield put( transactionLimitConfigApiSucess(response.data?.result));
      action?.payload?.callback?.(response.data?.result);
    } else {
      ToastNotifyError(response?.data?.message);
      yield put(transactionLimitConfigApiFailed(response));
    }
  }
  catch (error) {
    yield put(transactionLimitConfigApiFailed(error));
  }
}

export default function* root(): Generator {
  yield takeLatest(callLaunchConfigApi.type, fetchLaunchConfig);
  yield takeLatest(callConfigApi.type, fetchConfig);
  yield takeLatest(getUserAttribute.type, fetchUserAttribute);
  yield takeLatest(callTransactionLimitConfigApi.type, fetchTransactionLimitConfig);
}
